import React from 'react';
import IconButton from '@mui/material/IconButton';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { Box, SxProps, Theme } from '@mui/material';
import { theme } from '../../constants/theme';
import { useThemeContext } from '../../hook/useThemeManager';
import { Cancel } from '@mui/icons-material';

export interface IAvatarSelection {
    children: JSX.Element;
    open: boolean;
    handleClose: () => void;
    paperStyle?: React.CSSProperties;
    childrenStyle?: SxProps<Theme>;
    paperSx?: SxProps<Theme>;
    disableClose?: boolean;
}

const GenericModal: React.FC<IAvatarSelection> = ({
    children,
    open,
    handleClose,
    paperStyle,
    childrenStyle,
    paperSx,
    disableClose,
}) => {
    const { themeStyle, device } = useThemeContext();

    return (
        <Box>
            <Dialog
                open={open}
                onClose={handleClose}
                color="blue"
                PaperProps={{
                    style: {
                        backgroundColor: theme[themeStyle].pure_black,
                        height: '60%',
                        width: device.isDesktop ? '30%' : '80%',
                        overflowY: 'scroll',
                        border: '1px solid grey',
                        borderRadius: 10,
                        ...paperStyle,
                    },
                    sx: paperSx,
                }}>
                <DialogContent sx={childrenStyle}>{children}</DialogContent>
                {!disableClose && (
                    <DialogActions sx={{ position: 'absolute', right: 0, top: 0 }}>
                        <IconButton
                            color="primary"
                            aria-label="Add Avatar"
                            onClick={handleClose}
                            style={{
                                borderRadius: '50%',
                                borderWidth: 1,
                                borderColor: theme[themeStyle].lightWhite,
                                width: 30,
                            }}>
                            <Cancel sx={{ color: theme[themeStyle].lightWhite }} />
                        </IconButton>
                    </DialogActions>
                )}
            </Dialog>
        </Box>
    );
};

export { GenericModal };
